export default "__VITE_ASSET__D6n28CUT__"